module.exports = __webpack_public_path__ + "static/media/html-paper.e0a84fe4.svg";